import React, { useEffect, useState } from "react";
import httpAction from "../../utils/httpAction";
import apis from "../../utils/apis";
import CustomFileUploader from "../../components/common/CustomFileUploader";
import { CardSkeleton } from "../../components/common/Skeleton";

const emptyForm = { name: "", role: "Home Buyer", area: "", rating: 5, text: "", image: "", status: "published", featured: true, sortOrder: 0 };

export default function Reviews() {
  const [form, setForm] = useState(emptyForm);
  const [editingId, setEditingId] = useState("");
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const loadReviews = async () => {
    setLoading(true);
    const result = await httpAction({ url: `${apis().reviewList}?admin=true` });
    setLoading(false);
    if (result?.status) setReviews(result.list || []);
  };

  useEffect(() => { loadReviews(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    const result = await httpAction({
      url: editingId ? `${apis().reviewUpdate}/${editingId}` : apis().reviewAdd,
      method: editingId ? 'PUT' : 'POST',
      body: form,
    });
    setSaving(false);
    if (result?.status) {
      setForm(emptyForm);
      setEditingId("");
      loadReviews();
    }
  };

  const editItem = (item) => {
    setEditingId(item._id);
    setForm({ ...emptyForm, ...item });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const deleteItem = async (id) => {
    if (!window.confirm('Delete this review?')) return;
    const result = await httpAction({ url: `${apis().reviewDelete}/${id}`, method: 'DELETE' });
    if (result?.status) loadReviews();
  };

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-4"><div><h2>Reviews CMS</h2><p className="text-muted mb-0">Create, update, and publish client reviews for the homepage.</p></div></div>
      <form className="card p-4 mb-4" onSubmit={submit}>
        <div className="row g-3">
          <div className="col-md-6"><label className="form-label">Client Name</label><input className="form-control" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required /></div>
          <div className="col-md-3"><label className="form-label">Role</label><input className="form-control" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} /></div>
          <div className="col-md-3"><label className="form-label">Area</label><input className="form-control" value={form.area} onChange={(e) => setForm({ ...form, area: e.target.value })} /></div>
          <div className="col-md-3"><label className="form-label">Rating</label><select className="form-select" value={form.rating} onChange={(e) => setForm({ ...form, rating: Number(e.target.value) })}>{[5,4,3,2,1].map((n)=><option key={n} value={n}>{n} Star</option>)}</select></div>
          <div className="col-md-3"><label className="form-label">Status</label><select className="form-select" value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}><option value="published">Published</option><option value="draft">Draft</option></select></div>
          <div className="col-md-3"><label className="form-label">Sort Order</label><input type="number" className="form-control" value={form.sortOrder} onChange={(e) => setForm({ ...form, sortOrder: Number(e.target.value) })} /></div>
          <div className="col-md-3 d-flex align-items-end"><div className="form-check"><input id="featuredReview" className="form-check-input" type="checkbox" checked={form.featured} onChange={(e) => setForm({ ...form, featured: e.target.checked })} /><label htmlFor="featuredReview" className="form-check-label">Featured</label></div></div>
          <div className="col-12"><label className="form-label">Review</label><textarea rows="4" className="form-control" value={form.text} onChange={(e) => setForm({ ...form, text: e.target.value })} required /></div>
          <div className="col-12"><label className="form-label">Client Image</label><CustomFileUploader multiple={false} onEdit={form.image ? [{ id: 'review-image', url: form.image, source: 'server' }] : []} onChange={(items) => setForm({ ...form, image: items?.[0]?.url || '' })} /></div>
        </div>
        <div className="d-flex gap-2 mt-4"><button className="btn btn-primary" disabled={saving}>{saving ? 'Saving...' : editingId ? 'Update Review' : 'Add Review'}</button>{editingId ? <button type="button" className="btn btn-light" onClick={() => { setEditingId(''); setForm(emptyForm); }}>Cancel Edit</button> : null}</div>
      </form>
      {loading ? <CardSkeleton count={3} height={200} /> : <div className="row g-3">{reviews.map((item) => <div className="col-md-6 col-xl-4" key={item._id}><div className="card h-100 p-3">{item.image ? <img src={`${apis().localUrl}${item.image}`} alt={item.name} className="img-fluid rounded mb-3" style={{height:200, objectFit:'cover'}} /> : null}<div className="d-flex justify-content-between align-items-start mb-2"><div><h5 className="mb-1">{item.name}</h5><div className="text-muted small">{item.role} {item.area ? `• ${item.area}` : ''}</div></div><span className="badge text-bg-dark">{item.rating}/5</span></div><p className="small text-muted mb-2">{item.status} • order {item.sortOrder}</p><p>{item.text}</p><div className="d-flex gap-2 mt-auto"><button type="button" className="btn btn-outline-primary btn-sm" onClick={() => editItem(item)}>Edit</button><button type="button" className="btn btn-outline-danger btn-sm" onClick={() => deleteItem(item._id)}>Delete</button></div></div></div>)}</div>}
    </div>
  );
}
